import axios from 'axios';
import { handleError } from '../utils/error';
const API_URL = process.env.PRODUCTS_API_URL;
/*
  CREATE
*/
/*
  READ
*/
export const getOrg = async () => {
    try {
        const response = await axios.get(`${API_URL}/org`);
        return response;
    }
    catch (error) {
        handleError('getOrg', error);
        return error.response;
    }
};
export const getProduct = async ({ itemNumber }) => {
    try {
        const response = await axios.get(`${API_URL}/products/${itemNumber}`);
        return response;
    }
    catch (error) {
        handleError('getProduct', error);
        return error.response;
    }
};
export const getAllProducts = async () => {
    try {
        const response = await axios.get(`${API_URL}/products`);
        return response;
    }
    catch (error) {
        handleError('getAllProducts', error);
        return error.response;
    }
};
export const getHub = async () => {
    try {
        const response = await axios.get(`${API_URL}/hub`);
        return response;
    }
    catch (error) {
        handleError('getHub', error);
        return error.response;
    }
};
export const getProductsAggregate = async () => {
    try {
        const response = await axios.get(`${API_URL}/aggregate`);
        return response;
    }
    catch (error) {
        handleError('getProductsAggregate', error);
        return error.response;
    }
};
/*
  UPDATE
*/
export const putOrg = async ({ token, data }) => {
    try {
        const response = await axios.put(`${API_URL}/org/${data._id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('putOrg', error);
        return error.response;
    }
};
export const putProduct = async ({ token, data }) => {
    try {
        const response = await axios.put(`${API_URL}/products`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('putProduct', error);
        return error.response;
    }
};
/*
  DELETE
*/
/*
  UNSORTED
*/
//# sourceMappingURL=Products.js.map